export default __webpack_public_path__ + "static/media/Pumpkin.666cafb0.jpg";